import React, { useState } from 'react';
import styled from 'styled-components';
import Logo from './elements/Logo';
import NavMenu from './elements/NavMenu';
import MenuButton from './elements/Button';

const StyledHeader = styled.header`
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${props => props.theme.zIndexHeader};
  height: 4rem; /* Adjusted height for compact header */
  background-color: rgba(255, 255, 255, 0.8); /* Semi-transparent background */
  backdrop-filter: blur(10px); /* Apply blur to background */
  -webkit-backdrop-filter: blur(10px); /* For Safari support */
  border-bottom: 1px solid rgba(255, 255, 255, 0.3); /* Optional border for separation */
  display: flex;
  align-items: center;

  @media (max-width: 64em) {
    height: 3rem; /* Reduce height on smaller screens */
  }
`;

const Navbar = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 85%;
  margin: 0 auto;
  height: 100%; /* Make it take full height of header */

  @media (max-width: 64em) {
    width: 90%; /* Increase width on smaller screens */
    position: relative; /* Allow absolute positioning for children */
  }
`;

const BurgerMenu = styled.span`
  width: ${props => (props.isCollapsed ? '2rem' : '1.5rem')};
  height: 2px;
  background-color: ${props => props.theme.text};
  position: absolute;
  top: 1rem; /* Adjusted to position at the top */
  right: 1rem; /* Place it to the right */
  transform: ${props =>
    props.isCollapsed ? 'rotate(90deg)' : 'rotate(0)'};
  transition: all 0.3s ease;
  cursor: pointer;

  &::before,
  &::after {
    content: ' ';
    position: absolute;
    height: 2px;
    width: ${props => (props.isCollapsed ? '1rem' : '1.5rem')};
    background-color: ${props => props.theme.text};
    transition: all 0.3s ease;
  }
  
  &::after {
    top: ${props => (props.isCollapsed ? '0.3rem' : '0.5rem')};
    transform: ${props => (props.isCollapsed ? 'rotate(-40deg)' : 'rotate(0)')};
  }
  
  &::before {
    bottom: ${props => (props.isCollapsed ? '0.3rem' : '0.5rem')};
    transform: ${props => (props.isCollapsed ? 'rotate(40deg)' : 'rotate(0)')};
  }
`;

const BurgerBtnContainer = styled.div`
  display: none;

  @media (max-width: 64em) {
    display: flex;
    align-items: center;
    justify-content: flex-end; /* Align to the right */
    position: absolute; /* Allow it to float above other content */
    top: 0; /* Align to the top */
    right: 0; /* Align to the right */
    z-index: 5; /* Make sure it's above other content */
  }
`;

function Header() {
  const [isCollapsed, setCollapseState] = useState(false);
  
  return (
    <StyledHeader isCollapsed={isCollapsed}>
      <Navbar>
        <Logo />
        <NavMenu isCollapsed={isCollapsed} setCollapseState={setCollapseState} />
        <div className="desktop">
          <MenuButton text="Become Member" link="https://www.airedify.in/" />
        </div>
        <BurgerBtnContainer onClick={() => setCollapseState(prevState => !prevState)}>
          <BurgerMenu isCollapsed={isCollapsed}></BurgerMenu>
        </BurgerBtnContainer>
      </Navbar>
    </StyledHeader>
  );
}

export default Header;
